module.exports = __webpack_public_path__ + "static/media/controlled-breathing.bc126890.png";